<template>
  <!--<img alt="Vue logo" src="./assets/logo.png">-->
  <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
  <div class="mdui-progress" v-if="showprogress">
    <div class="mdui-progress-indeterminate"></div>
  </div>

  <div class="mdui-container mdui-theme-accent-blue ">

  <div class="mdui-textfield mdui-textfield-floating-label ">
    <label class="mdui-textfield-label">输入歌名,歌手,专辑名或歌单id等</label>
  <input class="mdui-textfield-input textcentre" v-model="str" >
  </div>

    <div class="horizon">
  <button class="mdui-btn mdui-btn-raised mdui-ripple mdui-color-theme-accent" style="margin-right:6px" @click="searchlist" >
   <!-- <i class="mdui-icon material-icons">&#xe8b6;</i>-->    搜索(网易云)</button>
      <button class="mdui-btn mdui-btn-raised mdui-ripple mdui-color-theme-accent" style="margin-right:6px" @click="searchlistkuwo" >
      <!--  <i class="mdui-icon material-icons">&#xe8b6;</i>  -->
        搜索(酷我)</button>
      <button class="mdui-btn mdui-btn-raised mdui-ripple mdui-color-theme-accent" @click="songlist">搜索歌单</button>
    </div>

  </div>
 <br>


  <!--搜索音乐弹窗-->
    <!-- 显示/隐藏弹窗 -->
    <div v-if="showModal" class="div2 mdui-theme-accent-blue">
        <!-- 弹窗标题 -->
      <div class="horizon">
        <h5>搜索"{{str}}"的结果</h5>
        <button class="mdui-btn mdui-btn-icon mdui-color-theme-accent mdui-ripple btnclose" @click="closeModal">
          <i class="mdui-icon material-icons ">&#xe5cd;</i>
          </button>
      </div>
      <div>
        <!-- 列表 -->
        <ul>
          <li class="mdui-list-item mdui-ripple"  v-for="item in items" :key="item" @click="search(item.id)">
            <div class="mdui-list-item-avatar"><img :src="item.picurl" alt="无"/></div>
            <div class="mdui-list-item-content"  >
              <div class="mdui-list-item-title">歌名:{{item.name}}</div>
              <div class="mdui-list-item-text mdui-list-item-one-line"><span
                  class="mdui-text-color-black">歌手:{{item.singers[0].name}}</span> <!-- - 专辑:{{item.album}}-->
              </div>
            </div>

          </li>
        </ul>
        <!-- 关闭弹窗按钮 -->
      </div>

    </div>

  <div v-if="kuwolist" class="div2 mdui-theme-accent-blue">
    <!-- 弹窗标题 -->
    <div class="horizon">
      <h5>搜索"{{str}}"的结果</h5>
      <button class="mdui-btn mdui-btn-icon mdui-color-theme-accent mdui-ripple btnclose" @click="closeModal">
        <i class="mdui-icon material-icons ">&#xe5cd;</i>
      </button>
    </div>
    <div>
      <!-- 列表 -->
      <ul>
        <li class="mdui-list-item mdui-ripple"  v-for="(item,index) in items" :key="index" @click="searchkuwo(index)">
          <div class="mdui-list-item-avatar"><img :src="item.picture" alt="无"/></div>
          <div class="mdui-list-item-content"  >
            <div class="mdui-list-item-title">歌名:{{item.song}}</div>
            <div class="mdui-list-item-text mdui-list-item-one-line"><span
                class="mdui-text-color-black">歌手:{{item.singer}}</span> - 专辑:{{item.album}}
            </div>
          </div>

        </li>
      </ul>
      <!-- 关闭弹窗按钮 -->
    </div>

  </div>
  <!--歌单弹窗-->
  <div v-if="showModal2" class="div2 mdui-theme-accent-blue">

    <!-- 弹窗标题 -->
    <div class="horizon">
      <h5>搜索"{{str}}"的结果</h5>
      <button class="mdui-btn mdui-btn-icon mdui-color-theme-accent mdui-ripple btnclose" @click="closeModal">
        <i class="mdui-icon material-icons ">&#xe5cd;</i>
      </button>
    </div>

    <!-- 列表 -->
    <ul>
      <li class="mdui-list-item mdui-ripple"  v-for="(item,index) in songitems" :key="index" @click="search(item.id)">

        <div class="mdui-list-item-content"  >
          <div class="mdui-list-item-title">歌名:{{item.album.name}}</div>
          <div class="mdui-list-item-text mdui-list-item-one-line"><span
              class="mdui-text-color-black">歌手:{{item.artists[0].name}}</span> <!-- - 专辑:{{item.album.name}}-->
          </div>
        </div>

      </li>
    </ul>
    <!-- 关闭弹窗按钮 -->


  </div>

  <br>
  <div class="mdui-container">
  <img :src="pic" alt="" >
  </div>

  <div class="horizon">
  <h4 style="margin-right: 15px;">歌手:{{singer}}</h4>
  <h4>专辑:{{album}}</h4>
  </div>


  <div class="bottom-fixed mdui-container">
    <aplayer
        ref="aplayer"
        :music="{
            title: title,
            artist: singer,
            src: song,
            pic: pic,
            lrc: lrc2,
            //theme: pic
            }"
        showLrc="true"
        theme="#7A88FF"
        autoplay="true"
        controls="true"

    />

  </div>



</template>


<script >
import aplayer from 'vue3-aplayer';
import {defineComponent} from "vue";
import axios from "axios";
//import {Base64} from "js-base64";


export default defineComponent({
  name:'App',
  data:function() {
return {
    str:"",
    song:"",
    //https://www.cnblogs.com/NExt-O/p/14173351.html
    pic:require("./assets/qq.png"),
    singer:"请先搜索",
    album:"请先搜索",
    title:"请先搜索 ",
    lrc2:"",
    songid: "",
    showModal:false,
    items:[],
    showprogress:false,
    songitems:[],
    showModal2:false,
    kuwolist:false,
    aplayer: null,
    aplayerInstance: null
};
},

  mounted() {
    this.$nextTick(() => {
      const playerRef = this.$refs.aplayer;
      if (playerRef?.player) {
        this.aplayerInstance = playerRef.player;
        this.initMediaSession();
        this.bindPlayerEvents();
      } else {
        console.warn('APlayer 实例未找到');
      }
    });
  },

  components: {aplayer} ,


  methods: {

    // ======================
    // MediaSession 初始化
    // ======================
    initMediaSession() {
      if (!('mediaSession' in navigator)) return;

      const handlers = {
        play: () => this.aplayerInstance?.play(),
        pause: () => this.aplayerInstance?.pause(),
        // 单曲模式下：上一首 → 重头播放
        previoustrack: () => {
          if (this.aplayerInstance) {
            this.aplayerInstance.seek(0);
            this.aplayerInstance.play();
          }
        },
        // 单曲模式下：下一首 → 可循环当前歌，或不做处理
        nexttrack: () => {
          if (this.aplayerInstance) {
            this.aplayerInstance.seek(0);   // 或什么都不做
          }
        },
        seekbackward: (details) => {
          if (this.aplayerInstance?.audio) {
            const offset = details.seekOffset || 10;
            this.aplayerInstance.seek(this.aplayerInstance.audio.currentTime - offset);
          }
        },
        seekforward: (details) => {
          if (this.aplayerInstance?.audio) {
            const offset = details.seekOffset || 10;
            this.aplayerInstance.seek(this.aplayerInstance.audio.currentTime + offset);
          }
        }
      };

      Object.entries(handlers).forEach(([action, handler]) => {
        try {
          navigator.mediaSession.setActionHandler(action, handler);
        } catch (e) {
          console.warn(`MediaSession action ${action} 不支持:`, e);
        }
      });
    },

    // 更新系统媒体信息（锁屏、任务栏、通知中心）
    updateMediaInfo() {
      if (!('mediaSession' in navigator) || !this.aplayerInstance) {
        console.log('❌ MediaSession 或 APlayer 未就绪');
        return;
      }

      let artworkUrl = this.pic || '';
      if (artworkUrl.startsWith('http://')) {
        artworkUrl = 'https:' + artworkUrl.substring(4);
      }

      console.log('🚀 正在设置 MediaSession:', this.title, this.singer, this.pic);

      navigator.mediaSession.metadata = new MediaMetadata({
        title: this.title,
        artist: this.singer,
        album: this.album,
        artwork: [
          { src: artworkUrl, sizes: '96x96',   type: 'image/jpeg' },
          { src: artworkUrl, sizes: '128x128', type: 'image/jpeg' },
          { src: artworkUrl, sizes: '256x256', type: 'image/jpeg' },
          { src: artworkUrl, sizes: '512x512', type: 'image/jpeg' }
        ]
      });

      // 更新播放状态
      const isPlaying = !this.aplayerInstance.audio?.paused;
      navigator.mediaSession.playbackState = isPlaying ? 'playing' : 'paused';

    },

    // 绑定 APlayer 事件
    bindPlayerEvents() {
      if (!this.aplayerInstance) return;

      this.aplayerInstance.on('play', () => {
        console.log('▶️ play 事件触发 → 更新 MediaSession');
        this.updateMediaInfo();
      });

      this.aplayerInstance.on('pause', () => {
        navigator.mediaSession.playbackState = 'paused';
      });

      this.aplayerInstance.on('ended', () => {
        navigator.mediaSession.playbackState = 'paused';
      });

      // 歌曲信息变化时更新
      this.aplayerInstance.on('switch', () => {
        this.updateMediaInfo();
      });
    },

    searchkuwo(index) {
      this.showprogress=true;

      axios({
        method: "get", //接口方法
        url: "apikuwo/", //接口
        params: {
          msg:this.str,
          n:index+1,
          br:2,
          limit: 50
        }

      }).then((res) => {
        this.song = res.data.data.url;
        //this.song=this.song.replace(/http/g,'https')
        this.pic = res.data.data.picture;
        //this.pic=this.pic.replace(/http/g,'https')
        this.singer = res.data.data.singer;
        this.album = res.data.data.album;
        this.title = res.data.data.song;
        this.songid = res.data.data.rid;


        this.showprogress=false
        this.showModal=false
        this.showModal2=false
        this.kuwolist=false

        this.updatePlayerAndMedia();

        //kuwo歌词
        const kuwolrc=this.songid.split("_")[1]
        axios({
          method:"get",
          url:"apikuwolrc/",
          params:{
            rid:kuwolrc
          }
        }).then((res) => {
              this.lrc2=res.data.data.lrc

            }
        ).catch((e) => {
          console.log(e)
        })

      }).catch((e) => {
        console.log(e)
        this.showprogress=false
        alert("音乐跑丢了,请刷新或稍后再试.")
      })
    },

    closeModal() {
      this.showModal = false
      this.showModal2 = false
      this.kuwolist=false
    },

    search:function (a) {

      this.showprogress=true;

      axios({
        method: "get", //接口方法
        url: "api/", //接口
        params: {
          id:a
        }

      }).then((res) => {
        this.song = res.data.data[0].url;
        this.song=this.song.replace(/http/g,'https')
        this.pic = res.data.data[0].picurl;
        this.singer = res.data.data[0].singers[0].name;
        //this.album = res.data.data.album;
        this.title = res.data.data[0].name;
        this.songid = res.data.data[0].id;


        this.showprogress=false
        this.showModal=false
        this.showModal2=false

        this.updatePlayerAndMedia();
        //获取qq歌词
        /*var jsonp;
        var lrcs;
        const url = 'api2/?g_tk=5381&inCharset=utf-8&outCharset=utf-8&needNewCode=1'
        axios.get(url, {
          params: {
            songmid: this.songmid
          }
        }).then((response) => {

          jsonp = response.data
          const startIndex = jsonp.indexOf('({');
          const endIndex = jsonp.indexOf('})');
          const jsonString = jsonp.slice(startIndex + 1, endIndex + 1);
          jsonp = JSON.parse(jsonString);
          lrcs = (jsonp.lyric);
          lrcs = Base64.decode(lrcs);
          this.lrc2=lrcs.replace(/&apos;/g,"'")

          //console.log(this.lrc2)
        }).catch((e) => {
          console.log(e)
        })
*/
        //网易云歌词
        axios({
          method:"get",
          url:"api2/",
          params:{
            id:this.songid
          }
        }).then((res) => {
          this.lrc2=res.data.lyric
            }
        ).catch((e) => {
          console.log(e)
        })

      }).catch((e) => {
        console.log(e)
        this.showprogress=false
        alert("音乐跑丢了,请刷新或稍后再试.")
      })

    },

    updatePlayerAndMedia() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.aplayerInstance) {
            this.aplayerInstance.play().then(() => {
              this.updateMediaInfo();        // 播放成功后再更新
            }).catch(err => {
              console.log('自动播放被阻止', err);
              this.updateMediaInfo();        // 即使被阻止也尝试设置
            });
          }
        }, 1800);
      });
    },

    searchlist:function () {

      this.showprogress=true
      let str = this.str
      //var songmid2;
      axios({
        method: "get", //接口方法
        url: "api/", //接口
        params: {
          name: str
        }

      }).then((res) => {
        this.items = res.data.data;
        this.showModal = true
        this.showprogress=false
        //console.log(res.data.data)
      }).catch((e) => {
        console.log(e)
        this.showprogress=false
        alert("音乐跑丢了,请刷新或稍后再试.")
      })

    },
    searchlistkuwo:function () {

      this.showprogress=true
      let str = this.str
      //var songmid2;
      axios({
        method: "get", //接口方法
        url: "apikuwo/", //接口
        params: {
          msg: str,
          limit: 50
        }

      }).then((res) => {
        this.items = res.data.data;
        this.kuwolist = true
        this.showprogress=false
        console.log(res.data.data)
      }).catch((e) => {
        console.log(e)
        this.showprogress=false
        alert("音乐跑丢了,请刷新或稍后再试.")
      })

    },

    songlist:function(){
      this.showprogress=true
      axios({
        method: "get", //接口方法
        //url: "api3/?format=json&newsong=1&platform=jqspaframe.json", //接口
        url:"api3/",
        params: {
            id:this.str //8454178511
        }

      }).then((res) => {
        this.songitems = res.data.data;
        this.showModal2 = true
        this.showprogress=false
        //console.log(res.data.data.cdlist[0])
        //console.log(this.songitems.cdlist[0])
      }).catch((e) => {
        console.log(e)
        this.showprogress=false
        alert("请输入网易云音乐歌单id,例如'774840811'")
      })
    }



  },



});
</script>




<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(45deg, #7A88FF, #7AFFAF);
  background-size: cover;
  /*margin-top: 30px;*/
}

.div2 {
  position: fixed;
  top: 30px;
  left: 25%;
  right: 20%;
  bottom: 60px;
  transform: none;
  background-color: #90CAF9;
  padding: 10px;
  border-radius: 20px;
  max-width: 60%;
  width: 50%;
  overflow: auto;
  z-index: 10;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
}


 img {
   width: 33%;
   border-radius: 15px;
 }

.bottom-fixed {
  border-radius: 20px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.horizon{
  display: flex;
  justify-content: center;
}

.textcentre{
  text-align: center;
}

.btnclose {
  position: fixed;
  top: 5%;
  left: 25%;

  /* 其他样式 */
}

@media only screen and (max-width: 767px) {
  img {
    width: 70%;
  }
  .div2 {
    top: 20px;
    left: 30px;

    bottom: 20px;
    transform: none;
    border-radius: 0;
    overflow: auto;
    z-index: 10;
    max-width: 80%;
    width: 80%;
  }

  .btnclose {
    position: fixed;
    top: 5%;
    left: 12%;
  }
}

</style>
